window.GTQ_CATALOG = {
  /***********************
   * GPU (Consumer Desktop)
   * - NA market naming
   * - Excludes workstation (Quadro/RTX A/Pro) and most OEM oddities
   ***********************/
  "GPU": {
    "NVIDIA": [
        // RTX 50 (Ada)
      "RTX 5090","RTX 5080","RTX 5070 Ti","RTX 5070","RTX 5060 Ti","RTX 5060","RTX 5050",
      // RTX 40 (Ada)
      "RTX 4090","RTX 4080","RTX 4080 SUPER","RTX 4070 Ti","RTX 4070 Ti SUPER","RTX 4070","RTX 4070 SUPER",
      "RTX 4060 Ti","RTX 4060","RTX 4050",

      // RTX 30 (Ampere)
      "RTX 3090 Ti","RTX 3090","RTX 3080 Ti","RTX 3080","RTX 3070 Ti","RTX 3070","RTX 3060 Ti","RTX 3060","RTX 3050",

      // RTX 20 (Turing)
      "RTX 2080 Ti","RTX 2080 SUPER","RTX 2080","RTX 2070 SUPER","RTX 2070","RTX 2060 SUPER","RTX 2060","RTX 2050",

      // GTX 16 (Turing)
      "GTX 1660 Ti","GTX 1660 SUPER","GTX 1660","GTX 1650 SUPER","GTX 1650",

      // GTX 10 (Pascal)
      "GTX 1080 Ti","GTX 1080","GTX 1070 Ti","GTX 1070","GTX 1060","GTX 1050 Ti","GTX 1050","GT 1030",
    ],

    "AMD": [
        // RX 9000 (RDNA3)
      "RX 9070 XT","RX 9070","RX 9070 GRE","RX 9060 XT",
      // RX 7000 (RDNA3)
      "RX 7900 XTX","RX 7900 XT","RX 7900 GRE","RX 7800 XT","RX 7700 XT","RX 7600 XT","RX 7600",

      // RX 6000 (RDNA2)
      "RX 6950 XT","RX 6900 XT","RX 6800 XT","RX 6800","RX 6750 XT","RX 6700 XT","RX 6650 XT",
      "RX 6600 XT","RX 6600","RX 6500 XT","RX 6400",

      // RX 5000 (RDNA1)
      "RX 5700 XT","RX 5700","RX 5600 XT","RX 5500 XT","RX 5500",

      // RX 500 (Polaris refresh)
      "RX 590","RX 580","RX 570","RX 560","RX 550",
    ]
  },

  /***********************
   * CPU (Consumer Desktop)
   * - Intel Core i3/i5/i7/i9 (6th gen -> 14th gen)
   * - AMD Ryzen 3/5/7/9 (1000 -> 7000)
   * - Includes mainstream SKUs that appear in NA used market
   * NOTE: Intel has *tons* of non-K/F variants. We include the common ones.
   ***********************/
  "CPU": {
  "Intel": [
    /* =========================
       Intel Core Ultra (Desktop)
       ========================= */

    // Core Ultra 9
    "Core Ultra 9 285K",
    "Core Ultra 9 285KF",

    // Core Ultra 7
    "Core Ultra 7 265K",
    "Core Ultra 7 265KF",

    // Core Ultra 5
    "Core Ultra 5 245K",
    "Core Ultra 5 245KF",

    /* =========================
       14th Gen (Raptor Lake Refresh)
       ========================= */
    "i9-14900K","i9-14900KF","i9-14900","i9-14900F",
    "i7-14700K","i7-14700KF","i7-14700","i7-14700F",
    "i5-14600K","i5-14600KF","i5-14600","i5-14600F",
    "i3-14100","i3-14100F",

    /* =========================
       13th Gen
       ========================= */
    "i9-13900KS","i9-13900K","i9-13900KF","i9-13900","i9-13900F",
    "i7-13700K","i7-13700KF","i7-13700","i7-13700F",
    "i5-13600K","i5-13600KF","i5-13600","i5-13600F",
    "i5-13500","i5-13400","i5-13400F",
    "i3-13100","i3-13100F",

    /* =========================
       12th Gen
       ========================= */
    "i9-12900KS","i9-12900K","i9-12900KF","i9-12900","i9-12900F",
    "i7-12700K","i7-12700KF","i7-12700","i7-12700F",
    "i5-12600K","i5-12600KF","i5-12600","i5-12500","i5-12400","i5-12400F",
    "i3-12100","i3-12100F",

    /* =========================
       11th → 6th Gen (Legacy but common)
       ========================= */
    "i9-11900K","i7-11700K","i5-11600K",
    "i9-10900K","i7-10700K","i5-10600K",
    "i7-9700K","i5-9600K",
    "i7-8700K","i5-8600K",
    "i7-7700K","i5-7600K",
    "i7-6700K","i5-6600K"
  ],

  "AMD": [
    /* =========================
       Ryzen 9000 (Zen 5, AM5)
       ========================= */
    "Ryzen 9 9950X3D",
    "Ryzen 9 9950X",
    "Ryzen 9 9900X3D",
    "Ryzen 9 9900X",
    "Ryzen 7 9850X3D",
    "Ryzen 7 9800X3D",
    "Ryzen 7 9700X",
    "Ryzen 5 9600X",
    "Ryzen 5 9600X3D",

    /* =========================
       Ryzen 7000 (AM5)
       ========================= */
    "Ryzen 9 7950X3D","Ryzen 9 7950X",
    "Ryzen 9 7900X3D","Ryzen 9 7900X","Ryzen 9 7900",
    "Ryzen 7 7800X3D","Ryzen 7 7700X","Ryzen 7 7700",
    "Ryzen 5 7600X","Ryzen 5 7600","Ryzen 5 7500F",

    /* =========================
       Ryzen 5000 (AM4)
       ========================= */
    "Ryzen 9 5950X","Ryzen 9 5900X",
    "Ryzen 7 5700X3D","Ryzen 7 5800X","Ryzen 7 5700X",
    "Ryzen 5 5600X","Ryzen 5 5600","Ryzen 5 5500",
    "Ryzen 3 5300G","Ryzen 3 4100",

    /* =========================
       Ryzen 3000
       ========================= */
    "Ryzen 9 3950X","Ryzen 9 3900X",
    "Ryzen 7 3800X","Ryzen 7 3700X",
    "Ryzen 5 3600X","Ryzen 5 3600",
    "Ryzen 3 3300X","Ryzen 3 3100",

    /* =========================
       Ryzen 2000 & 1000
       ========================= */
    "Ryzen 7 2700X","Ryzen 5 2600X","Ryzen 5 2600",
    "Ryzen 7 1800X","Ryzen 5 1600X","Ryzen 5 1600"
  ]
},

  /***********************
   * Motherboard (Practical trade-in structure)
   * - Use chipset/socket tiers (way more usable than listing thousands of models)
   ***********************/
  "Motherboard": {

     "Intel LGA1851 (Core Ultra)": [
      "Z890 (High-end)",
      "B860 (Mainstream)",
      "H810 (Entry)"
    ],
  "Intel LGA1700 (12th–14th Gen)": [
    "Z790 (High-end)",
    "Z690 (High-end)",
    "B760 (Mainstream)",
    "B660 (Mainstream)",
    "H770 (Mainstream)",
    "H670 (Mainstream)",
    "H610 (Entry)"
  ],
  "Intel LGA1200 (10th–11th Gen)": [
    "Z590 (High-end)",
    "Z490 (High-end)",
    "B560 (Mainstream)",
    "B460 (Mainstream)",
    "H570 (Mainstream)",
    "H470 (Mainstream)",
    "H510 (Entry)",
    "H410 (Entry)"
  ],
  "Intel LGA1151 (6th–9th Gen)": [
    "Z390 (High-end)",
    "Z370 (High-end)",
    "Z270 (High-end)",
    "Z170 (High-end)",
    "B365 (Mainstream)",
    "B360 (Mainstream)",
    "B250 (Mainstream)",
    "B150 (Mainstream)",
    "H370 (Mainstream)",
    "H270 (Mainstream)",
    "H170 (Mainstream)",
    "H310 (Entry)",
    "H110 (Entry)"
  ],

  "AMD AM5 (Ryzen 7000)": [
    "X870E (High-end)",
    "X870 (High-end)",
    "B850E (Mainstream+)",
    "B850 (Mainstream)",
    "X670E (High-end)",
    "X670 (High-end)",
    "B650E (Mainstream+)",
    "B650 (Mainstream)",
    "A620 (Entry)"
  ],
  "AMD AM4 (Ryzen 1000–5000)": [
    "X570 (High-end)",
    "X470 (High-end)",
    "X370 (High-end)",
    "B550 (Mainstream)",
    "B450 (Mainstream)",
    "B350 (Mainstream)",
    "A520 (Entry)",
    "A320 (Entry)"
  ]
},

  /***********************
   * RAM (Consumer)
   ***********************/
  "RAM": {
  "DDR5": [
    "16GB",
    "32GB",
    "48GB",
    "64GB",
    "128GB"
  ],
  "DDR4": [
    "8GB",
    "16GB",
    "32GB",
    "64GB",
    "128GB"
  ],
  "DDR3 (Legacy)": [
    "4GB",
    "8GB",
    "16GB",
    "32GB",
    "64GB",
    "128GB"
  ]
},

  /***********************
   * Storage (Consumer)
   ***********************/
  "Storage": {
    "NVMe SSD": [
      "250GB","500GB","1TB","2TB","4TB","8TB",
    ],
    "SATA SSD": [
      "120GB","240GB","480GB","500GB","1TB","2TB","4TB"
    ],
    "HDD": [
      "500GB","1TB","2TB","4TB","6TB","8TB","10TB","12TB","14TB","16TB"
    ]
  },

  /***********************
   * Full Gaming PC (keep simple for now)
   ***********************/
  "Full Gaming PC": {
    "GamerTech": ["Entry (1080p)","Mid (1440p)","High (4K)","Ultra (Flagship)"]
  }
};
